module.exports = __webpack_public_path__ + "img/portfolio.555ec3dd.png";